import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import AuthLayout from '@/layouts/AuthLayout.vue'
import DashboardLayout from '@/layouts/DashboardLayout.vue'
import LoginPage from '@/views/LoginPage.vue'
import MainPage from '@/views/MainPage.vue'
import ResourcePage from '@/views/ResourcePage.vue'
import ProfilePage from '@/views/ProfilePage.vue'
import TasksPage from '@/views/TasksPage.vue'
import TaskDetailPage from '@/views/TaskDetailPage.vue'
import { SECTIONS } from '@/config/setting'
import { clearPushDevice } from '@/utils/push'
import { loginDestination } from '@/utils/loginRedirect'
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/login', component: AuthLayout, children: [{ path: '', component: LoginPage }] },
    { path: '/', component: DashboardLayout, meta: { requiresAuth: true }, children: [
      { path: '', redirect: '/main' },
      { path: 'main', component: MainPage },
      { path: 'tasks', component: TasksPage },
      { path: 'tasks/:id(\\d+)', component: TaskDetailPage },
      ...SECTIONS.slice(1, -1).filter(section => section.path !== '/tasks').map(section => ({ path: section.path.slice(1), component: ResourcePage, props: { resource: section.path.slice(1), title: section.title } })),
      { path: 'profile', component: ProfilePage }
    ] },
    { path: '/:pathMatch(.*)*', redirect: '/main' }
  ]
})
router.beforeEach(async to => {
  if (!store.state.loaded) {
    try { await store.dispatch('fetchUser') } catch { if (to.path !== '/login') return { path: '/login', query: { redirect: loginDestination(to.fullPath) } } }
  }
  if (to.meta.requiresAuth && !store.getters.authenticated) return { path: '/login', query: { redirect: loginDestination(to.fullPath) } }
  if (to.path === '/seo' && !store.state.hasSeo) return '/reports'
  if (to.path === '/login' && store.getters.authenticated) return loginDestination(to.query.redirect)
  document.title = `${to.path.startsWith('/tasks/') ? 'Задача' : SECTIONS.find(s => s.path === to.path)?.title || 'Вход'} · Кабинет клиента`
})
window.addEventListener('portal-session-expired', () => {
  clearPushDevice().catch(() => {})
  store.commit('clearUser')
  if (router.currentRoute.value.path !== '/login') router.replace({ path: '/login', query: { redirect: loginDestination(router.currentRoute.value.fullPath) } })
})
export default router
